import React from 'react';
import { Layout, Menu, Icon, Tag, Badge } from 'antd';
import { Link } from 'react-router-dom';


const { SubMenu, Item } = Menu;
const { Header } = Layout;

export default function MainHeader(props) {
    const fetchIconoAplicacion = () => {
        if (props.aplicacion === undefined)
            return null;

        if (props.aplicacion.iconoPersonalizado) {
            return <img
                src={require('../assets/images/' + props.aplicacion.icono)}
                style={{ height: "18px", marginRight: '11px', marginBottom: '3px' }}
                alt="icon"
            />
        }
        else
            return <Icon type={props.aplicacion.icono} style={{ fontSize: '18px' }} />
    }
    return (
        <Header style={{ background: '#fff', padding: 0 }}>
            <div className="layout-content-logo">
                <div className="child-2">
                    <Link to='/' >
                        <img
                            style={{ height: '55px' }}
                            src={require('../assets/images/logo-blanco.png')}
                            className="logo-page"
                            alt="logo"
                        />
                        <img
                            src={require('../assets/images/logo-mobile.png')}
                            className="logo-mobile"
                            alt="logo"
                        />
                    </Link>
                </div>
            </div>
            <Menu
                theme="light"
                mode="horizontal"
                className="layout-main-header text-center"
                style={{
                    color: '#ffffff',
                    backgroundColor: '#1890ff',
                    fontWeight: 'bold'
                }}
                selectedKeys={[`applicacion-${(props.aplicacion === undefined ? '' : props.aplicacion.id)}`]}
            >
                <Item key="20jtt" className="ignore">
                    <Link to={"/"} style={{ color: 'white', fontWeight: 'normal' }} >
                        <span style={{ border: '1px solid #ffffff', borderRadius: '5px' }} className="layout-tag-application">{props.aplicacion === undefined ? '' : props.aplicacion.nombre}</span>
                    </Link>
                </Item>
                <Item key="34cddfty" className="ignore" style={{ width: '20px' }}>

                </Item>
                <Item key="6756jfd" className="ignore" >
                    <Link to={"#"} style={{ color: 'white', fontWeight: 'normal' }} >
                        <span color={"blue"} className="layout-tag-application"> <Icon style={{ fontSize: '20px', color: '#ffffff' }} type="question-circle" />{'Ayuda'}</span>
                    </Link>
                </Item>
                <Item key="34cfty" className="ignore">
                    <Link to={"#"} style={{ color: 'white', fontWeight: 'normal' }} >
                        <span color={"blue"} className="layout-tag-application"><Icon style={{ fontSize: '20px', color: '#ffffff' }} type="usergroup-add" />{'Soporte'}</span>
                    </Link>
                </Item>
                <Item key="okt7" className="ignore">
                    <Link to={"#"} style={{ color: 'white', fontWeight: 'normal' }} >
                        <Icon style={{ fontSize: '20px', color: '#ffffff' }} type="message" />
                        <Icon style={{ fontSize: '20px', color: '#ffffff' }} type="mail" />
                    </Link>
                </Item>


                <Item key="terter" className="ignore" style={{ width: '350px' }} onClick={props.onShowNotification}>
                    <Link to={"#"} style={{
                        color: 'white',
                        textOverflow: 'ellipsis',
                        overflow: 'hidden',
                        fontWeight: 'normal'
                    }} >
                        <Badge count={props.notificationCount}>
                            <Icon style={{ fontSize: '23px', color: '#ffffff' }} type="bell" />
                        </Badge>
                        <span color={"blue"} className="layout-tag-application"><Icon style={{ fontSize: '20px', color: '#ffffff' }} type="bank" />
                            {props.user ? props.user.customerName : ''}
                        </span>
                    </Link>
                </Item>
                <SubMenu
                    style={{ float: 'right', fontWeight: 'normal', color: 'white' }}
                    title={
                        <span className="submenu-title-wrapper"><Icon type="user" />
                            {props.user ? props.user.nombre : ''}
                        </span>}
                >
                    {
                        (props.user?.flagAdministrador ? props.mainOptions : props.mainOptions.filter(m => m.id !== 1))
                            .map(item => (
                                <Item key={item.id}>
                                    <Link
                                        to={item.url}
                                        style={{ textDecoration: 'none', fontWeight: 'normal', }}
                                    >
                                        {
                                            item.iconoPersonalizado ?
                                                <img
                                                    src={require('../assets/images/' + item.icono)}
                                                    style={{ height: "14px", marginRight: '11px', marginBottom: '3px' }}
                                                    alt="icon"
                                                /> :
                                                <Icon type={item.icono} />
                                        }
                                        {item.nombre}
                                    </Link>
                                </Item>
                            ))
                    }
                    <Item key="setting:8" onClick={props.onSignout}><Icon type="logout" />Salir</Item>
                </SubMenu>
            </Menu>
        </Header >
    );
}